var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLateIndenting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 31.697,
    viewBox: "0 0 34 31.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Late_indenting",
    "data-name": "Late indenting",
    d: "M189.188,198.627a15.872,15.872,0,0,1-30.531,6.06,1.342,1.342,0,0,1,.738-1.787,1.373,1.373,0,0,1,1.787.738,13.072,13.072,0,1,0-.311-9.323l.466-.5a1.375,1.375,0,0,1,2.02,1.865l-3.535,3.884a1.45,1.45,0,0,1-1.01.466h-.194a1.365,1.365,0,0,1-1.049-.777l-2.253-4.817a1.373,1.373,0,0,1,2.486-1.165l.311.7a15.894,15.894,0,0,1,31.076,4.661Zm-15.421-7.575a1.359,1.359,0,0,0-2.719,0v7.575a1.35,1.35,0,0,0,.388.971l5.361,5.361a1.373,1.373,0,0,0,1.942-1.942l-4.972-4.972v-6.992Z",
    transform: "translate(-155.189 -182.779)",
    fill: "#ff7200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateIndenting);
export default __webpack_public_path__ + "static/media/LateIndenting.9c0d363d5518c5c59af5ad25b5cd6e8e.svg";
export { ForwardRef as ReactComponent };